//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, c = (n, r, a) => (a = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), l = /* @__PURE__ */ c((/* @__PURE__ */ o(((e, t) => {
	(function(e, n) {
		var r = {};
		n(r);
		var i = r.default;
		for (var a in r) i[a] = r[a];
		typeof t == "object" && typeof t.exports == "object" ? t.exports = i : typeof define == "function" && define.amd ? define(function() {
			return i;
		}) : e.sha256 = i;
	})(e, function(e) {
		e.__esModule = !0, e.digestLength = 32, e.blockSize = 64;
		var t = new Uint32Array([
			1116352408,
			1899447441,
			3049323471,
			3921009573,
			961987163,
			1508970993,
			2453635748,
			2870763221,
			3624381080,
			310598401,
			607225278,
			1426881987,
			1925078388,
			2162078206,
			2614888103,
			3248222580,
			3835390401,
			4022224774,
			264347078,
			604807628,
			770255983,
			1249150122,
			1555081692,
			1996064986,
			2554220882,
			2821834349,
			2952996808,
			3210313671,
			3336571891,
			3584528711,
			113926993,
			338241895,
			666307205,
			773529912,
			1294757372,
			1396182291,
			1695183700,
			1986661051,
			2177026350,
			2456956037,
			2730485921,
			2820302411,
			3259730800,
			3345764771,
			3516065817,
			3600352804,
			4094571909,
			275423344,
			430227734,
			506948616,
			659060556,
			883997877,
			958139571,
			1322822218,
			1537002063,
			1747873779,
			1955562222,
			2024104815,
			2227730452,
			2361852424,
			2428436474,
			2756734187,
			3204031479,
			3329325298
		]);
		function n(e, n, r, i, a) {
			for (var o, s, c, l, u, d, f, p, m, h, g, _, v; a >= 64;) {
				for (o = n[0], s = n[1], c = n[2], l = n[3], u = n[4], d = n[5], f = n[6], p = n[7], h = 0; h < 16; h++) g = i + h * 4, e[h] = (r[g] & 255) << 24 | (r[g + 1] & 255) << 16 | (r[g + 2] & 255) << 8 | r[g + 3] & 255;
				for (h = 16; h < 64; h++) m = e[h - 2], _ = (m >>> 17 | m << 15) ^ (m >>> 19 | m << 13) ^ m >>> 10, m = e[h - 15], v = (m >>> 7 | m << 25) ^ (m >>> 18 | m << 14) ^ m >>> 3, e[h] = (_ + e[h - 7] | 0) + (v + e[h - 16] | 0);
				for (h = 0; h < 64; h++) _ = (((u >>> 6 | u << 26) ^ (u >>> 11 | u << 21) ^ (u >>> 25 | u << 7)) + (u & d ^ ~u & f) | 0) + (p + (t[h] + e[h] | 0) | 0) | 0, v = ((o >>> 2 | o << 30) ^ (o >>> 13 | o << 19) ^ (o >>> 22 | o << 10)) + (o & s ^ o & c ^ s & c) | 0, p = f, f = d, d = u, u = l + _ | 0, l = c, c = s, s = o, o = _ + v | 0;
				n[0] += o, n[1] += s, n[2] += c, n[3] += l, n[4] += u, n[5] += d, n[6] += f, n[7] += p, i += 64, a -= 64;
			}
			return i;
		}
		var r = function() {
			function t() {
				this.digestLength = e.digestLength, this.blockSize = e.blockSize, this.state = new Int32Array(8), this.temp = new Int32Array(64), this.buffer = new Uint8Array(128), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1, this.reset();
			}
			return t.prototype.reset = function() {
				return this.state[0] = 1779033703, this.state[1] = 3144134277, this.state[2] = 1013904242, this.state[3] = 2773480762, this.state[4] = 1359893119, this.state[5] = 2600822924, this.state[6] = 528734635, this.state[7] = 1541459225, this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1, this;
			}, t.prototype.clean = function() {
				for (var e = 0; e < this.buffer.length; e++) this.buffer[e] = 0;
				for (var e = 0; e < this.temp.length; e++) this.temp[e] = 0;
				this.reset();
			}, t.prototype.update = function(e, t) {
				if (t === void 0 && (t = e.length), this.finished) throw Error("SHA256: can't update because hash was finished.");
				var r = 0;
				if (this.bytesHashed += t, this.bufferLength > 0) {
					for (; this.bufferLength < 64 && t > 0;) this.buffer[this.bufferLength++] = e[r++], t--;
					this.bufferLength === 64 && (n(this.temp, this.state, this.buffer, 0, 64), this.bufferLength = 0);
				}
				for (t >= 64 && (r = n(this.temp, this.state, e, r, t), t %= 64); t > 0;) this.buffer[this.bufferLength++] = e[r++], t--;
				return this;
			}, t.prototype.finish = function(e) {
				if (!this.finished) {
					var t = this.bytesHashed, r = this.bufferLength, i = t / 536870912 | 0, a = t << 3, o = t % 64 < 56 ? 64 : 128;
					this.buffer[r] = 128;
					for (var s = r + 1; s < o - 8; s++) this.buffer[s] = 0;
					this.buffer[o - 8] = i >>> 24 & 255, this.buffer[o - 7] = i >>> 16 & 255, this.buffer[o - 6] = i >>> 8 & 255, this.buffer[o - 5] = i >>> 0 & 255, this.buffer[o - 4] = a >>> 24 & 255, this.buffer[o - 3] = a >>> 16 & 255, this.buffer[o - 2] = a >>> 8 & 255, this.buffer[o - 1] = a >>> 0 & 255, n(this.temp, this.state, this.buffer, 0, o), this.finished = !0;
				}
				for (var s = 0; s < 8; s++) e[s * 4 + 0] = this.state[s] >>> 24 & 255, e[s * 4 + 1] = this.state[s] >>> 16 & 255, e[s * 4 + 2] = this.state[s] >>> 8 & 255, e[s * 4 + 3] = this.state[s] >>> 0 & 255;
				return this;
			}, t.prototype.digest = function() {
				var e = new Uint8Array(this.digestLength);
				return this.finish(e), e;
			}, t.prototype._saveState = function(e) {
				for (var t = 0; t < this.state.length; t++) e[t] = this.state[t];
			}, t.prototype._restoreState = function(e, t) {
				for (var n = 0; n < this.state.length; n++) this.state[n] = e[n];
				this.bytesHashed = t, this.finished = !1, this.bufferLength = 0;
			}, t;
		}();
		e.Hash = r;
		var i = function() {
			function e(e) {
				this.inner = new r(), this.outer = new r(), this.blockSize = this.inner.blockSize, this.digestLength = this.inner.digestLength;
				var t = new Uint8Array(this.blockSize);
				if (e.length > this.blockSize) new r().update(e).finish(t).clean();
				else for (var n = 0; n < e.length; n++) t[n] = e[n];
				for (var n = 0; n < t.length; n++) t[n] ^= 54;
				this.inner.update(t);
				for (var n = 0; n < t.length; n++) t[n] ^= 106;
				this.outer.update(t), this.istate = new Uint32Array(8), this.ostate = new Uint32Array(8), this.inner._saveState(this.istate), this.outer._saveState(this.ostate);
				for (var n = 0; n < t.length; n++) t[n] = 0;
			}
			return e.prototype.reset = function() {
				return this.inner._restoreState(this.istate, this.inner.blockSize), this.outer._restoreState(this.ostate, this.outer.blockSize), this;
			}, e.prototype.clean = function() {
				for (var e = 0; e < this.istate.length; e++) this.ostate[e] = this.istate[e] = 0;
				this.inner.clean(), this.outer.clean();
			}, e.prototype.update = function(e) {
				return this.inner.update(e), this;
			}, e.prototype.finish = function(e) {
				return this.outer.finished ? this.outer.finish(e) : (this.inner.finish(e), this.outer.update(e, this.digestLength).finish(e)), this;
			}, e.prototype.digest = function() {
				var e = new Uint8Array(this.digestLength);
				return this.finish(e), e;
			}, e;
		}();
		e.HMAC = i;
		function a(e) {
			var t = new r().update(e), n = t.digest();
			return t.clean(), n;
		}
		e.hash = a, e.default = a;
		function o(e, t) {
			var n = new i(e).update(t), r = n.digest();
			return n.clean(), r;
		}
		e.hmac = o;
		function s(e, t, n, r) {
			var i = r[0];
			if (i === 0) throw Error("hkdf: cannot expand more");
			t.reset(), i > 1 && t.update(e), n && t.update(n), t.update(r), t.finish(e), r[0]++;
		}
		var c = new Uint8Array(e.digestLength);
		function l(e, t, n, r) {
			t === void 0 && (t = c), r === void 0 && (r = 32);
			for (var a = new Uint8Array([1]), l = new i(o(t, e)), u = new Uint8Array(l.digestLength), d = u.length, f = new Uint8Array(r), p = 0; p < r; p++) d === u.length && (s(u, l, n, a), d = 0), f[p] = u[d++];
			return l.clean(), u.fill(0), a.fill(0), f;
		}
		e.hkdf = l;
		function u(e, t, n, r) {
			for (var a = new i(e), o = a.digestLength, s = new Uint8Array(4), c = new Uint8Array(o), l = new Uint8Array(o), u = new Uint8Array(r), d = 0; d * o < r; d++) {
				var f = d + 1;
				s[0] = f >>> 24 & 255, s[1] = f >>> 16 & 255, s[2] = f >>> 8 & 255, s[3] = f >>> 0 & 255, a.reset(), a.update(t), a.update(s), a.finish(l);
				for (var p = 0; p < o; p++) c[p] = l[p];
				for (var p = 2; p <= n; p++) {
					a.reset(), a.update(l).finish(l);
					for (var m = 0; m < o; m++) c[m] ^= l[m];
				}
				for (var p = 0; p < o && d * o + p < r; p++) u[d * o + p] = c[p];
			}
			for (var d = 0; d < o; d++) c[d] = l[d] = 0;
			for (var d = 0; d < 4; d++) s[d] = 0;
			return a.clean(), u;
		}
		e.pbkdf2 = u;
	});
})))(), 1);
async function u(e, t = "SHA-256") {
	let n = new TextEncoder().encode(e), r = await crypto.subtle.digest(t, n);
	return d(new Uint8Array(r));
}
function d(e) {
	return Array.from(e).map((e) => e.toString(16).padStart(2, "0")).join("");
}
function f(e, t = "SHA-256") {
	if (t !== "SHA-256") throw Error(`Unsupported algorithm: ${t}. Only SHA-256 is supported in hashSync.`);
	return d((0, l.default)(new TextEncoder().encode(e)));
}
//#endregion
//#region src/isJSON.ts
function p(e) {
	if (typeof e != "string") return !1;
	try {
		return JSON.parse(e), !0;
	} catch {
		return !1;
	}
}
//#endregion
//#region src/kebabCaseToPascalCase.ts
function m(e) {
	return e.split("-").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join("");
}
//#endregion
//#region src/pascalCaseToKebabCase.ts
function h(e) {
	return e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z])([A-Z][a-z])/g, "$1-$2").toLowerCase();
}
//#endregion
//#region ../../node_modules/.pnpm/cssfilter@0.0.10/node_modules/cssfilter/lib/default.js
var g = /* @__PURE__ */ o(((e) => {
	function t() {
		var e = {};
		return e["align-content"] = !1, e["align-items"] = !1, e["align-self"] = !1, e["alignment-adjust"] = !1, e["alignment-baseline"] = !1, e.all = !1, e["anchor-point"] = !1, e.animation = !1, e["animation-delay"] = !1, e["animation-direction"] = !1, e["animation-duration"] = !1, e["animation-fill-mode"] = !1, e["animation-iteration-count"] = !1, e["animation-name"] = !1, e["animation-play-state"] = !1, e["animation-timing-function"] = !1, e.azimuth = !1, e["backface-visibility"] = !1, e.background = !0, e["background-attachment"] = !0, e["background-clip"] = !0, e["background-color"] = !0, e["background-image"] = !0, e["background-origin"] = !0, e["background-position"] = !0, e["background-repeat"] = !0, e["background-size"] = !0, e["baseline-shift"] = !1, e.binding = !1, e.bleed = !1, e["bookmark-label"] = !1, e["bookmark-level"] = !1, e["bookmark-state"] = !1, e.border = !0, e["border-bottom"] = !0, e["border-bottom-color"] = !0, e["border-bottom-left-radius"] = !0, e["border-bottom-right-radius"] = !0, e["border-bottom-style"] = !0, e["border-bottom-width"] = !0, e["border-collapse"] = !0, e["border-color"] = !0, e["border-image"] = !0, e["border-image-outset"] = !0, e["border-image-repeat"] = !0, e["border-image-slice"] = !0, e["border-image-source"] = !0, e["border-image-width"] = !0, e["border-left"] = !0, e["border-left-color"] = !0, e["border-left-style"] = !0, e["border-left-width"] = !0, e["border-radius"] = !0, e["border-right"] = !0, e["border-right-color"] = !0, e["border-right-style"] = !0, e["border-right-width"] = !0, e["border-spacing"] = !0, e["border-style"] = !0, e["border-top"] = !0, e["border-top-color"] = !0, e["border-top-left-radius"] = !0, e["border-top-right-radius"] = !0, e["border-top-style"] = !0, e["border-top-width"] = !0, e["border-width"] = !0, e.bottom = !1, e["box-decoration-break"] = !0, e["box-shadow"] = !0, e["box-sizing"] = !0, e["box-snap"] = !0, e["box-suppress"] = !0, e["break-after"] = !0, e["break-before"] = !0, e["break-inside"] = !0, e["caption-side"] = !1, e.chains = !1, e.clear = !0, e.clip = !1, e["clip-path"] = !1, e["clip-rule"] = !1, e.color = !0, e["color-interpolation-filters"] = !0, e["column-count"] = !1, e["column-fill"] = !1, e["column-gap"] = !1, e["column-rule"] = !1, e["column-rule-color"] = !1, e["column-rule-style"] = !1, e["column-rule-width"] = !1, e["column-span"] = !1, e["column-width"] = !1, e.columns = !1, e.contain = !1, e.content = !1, e["counter-increment"] = !1, e["counter-reset"] = !1, e["counter-set"] = !1, e.crop = !1, e.cue = !1, e["cue-after"] = !1, e["cue-before"] = !1, e.cursor = !1, e.direction = !1, e.display = !0, e["display-inside"] = !0, e["display-list"] = !0, e["display-outside"] = !0, e["dominant-baseline"] = !1, e.elevation = !1, e["empty-cells"] = !1, e.filter = !1, e.flex = !1, e["flex-basis"] = !1, e["flex-direction"] = !1, e["flex-flow"] = !1, e["flex-grow"] = !1, e["flex-shrink"] = !1, e["flex-wrap"] = !1, e.float = !1, e["float-offset"] = !1, e["flood-color"] = !1, e["flood-opacity"] = !1, e["flow-from"] = !1, e["flow-into"] = !1, e.font = !0, e["font-family"] = !0, e["font-feature-settings"] = !0, e["font-kerning"] = !0, e["font-language-override"] = !0, e["font-size"] = !0, e["font-size-adjust"] = !0, e["font-stretch"] = !0, e["font-style"] = !0, e["font-synthesis"] = !0, e["font-variant"] = !0, e["font-variant-alternates"] = !0, e["font-variant-caps"] = !0, e["font-variant-east-asian"] = !0, e["font-variant-ligatures"] = !0, e["font-variant-numeric"] = !0, e["font-variant-position"] = !0, e["font-weight"] = !0, e.grid = !1, e["grid-area"] = !1, e["grid-auto-columns"] = !1, e["grid-auto-flow"] = !1, e["grid-auto-rows"] = !1, e["grid-column"] = !1, e["grid-column-end"] = !1, e["grid-column-start"] = !1, e["grid-row"] = !1, e["grid-row-end"] = !1, e["grid-row-start"] = !1, e["grid-template"] = !1, e["grid-template-areas"] = !1, e["grid-template-columns"] = !1, e["grid-template-rows"] = !1, e["hanging-punctuation"] = !1, e.height = !0, e.hyphens = !1, e.icon = !1, e["image-orientation"] = !1, e["image-resolution"] = !1, e["ime-mode"] = !1, e["initial-letters"] = !1, e["inline-box-align"] = !1, e["justify-content"] = !1, e["justify-items"] = !1, e["justify-self"] = !1, e.left = !1, e["letter-spacing"] = !0, e["lighting-color"] = !0, e["line-box-contain"] = !1, e["line-break"] = !1, e["line-grid"] = !1, e["line-height"] = !1, e["line-snap"] = !1, e["line-stacking"] = !1, e["line-stacking-ruby"] = !1, e["line-stacking-shift"] = !1, e["line-stacking-strategy"] = !1, e["list-style"] = !0, e["list-style-image"] = !0, e["list-style-position"] = !0, e["list-style-type"] = !0, e.margin = !0, e["margin-bottom"] = !0, e["margin-left"] = !0, e["margin-right"] = !0, e["margin-top"] = !0, e["marker-offset"] = !1, e["marker-side"] = !1, e.marks = !1, e.mask = !1, e["mask-box"] = !1, e["mask-box-outset"] = !1, e["mask-box-repeat"] = !1, e["mask-box-slice"] = !1, e["mask-box-source"] = !1, e["mask-box-width"] = !1, e["mask-clip"] = !1, e["mask-image"] = !1, e["mask-origin"] = !1, e["mask-position"] = !1, e["mask-repeat"] = !1, e["mask-size"] = !1, e["mask-source-type"] = !1, e["mask-type"] = !1, e["max-height"] = !0, e["max-lines"] = !1, e["max-width"] = !0, e["min-height"] = !0, e["min-width"] = !0, e["move-to"] = !1, e["nav-down"] = !1, e["nav-index"] = !1, e["nav-left"] = !1, e["nav-right"] = !1, e["nav-up"] = !1, e["object-fit"] = !1, e["object-position"] = !1, e.opacity = !1, e.order = !1, e.orphans = !1, e.outline = !1, e["outline-color"] = !1, e["outline-offset"] = !1, e["outline-style"] = !1, e["outline-width"] = !1, e.overflow = !1, e["overflow-wrap"] = !1, e["overflow-x"] = !1, e["overflow-y"] = !1, e.padding = !0, e["padding-bottom"] = !0, e["padding-left"] = !0, e["padding-right"] = !0, e["padding-top"] = !0, e.page = !1, e["page-break-after"] = !1, e["page-break-before"] = !1, e["page-break-inside"] = !1, e["page-policy"] = !1, e.pause = !1, e["pause-after"] = !1, e["pause-before"] = !1, e.perspective = !1, e["perspective-origin"] = !1, e.pitch = !1, e["pitch-range"] = !1, e["play-during"] = !1, e.position = !1, e["presentation-level"] = !1, e.quotes = !1, e["region-fragment"] = !1, e.resize = !1, e.rest = !1, e["rest-after"] = !1, e["rest-before"] = !1, e.richness = !1, e.right = !1, e.rotation = !1, e["rotation-point"] = !1, e["ruby-align"] = !1, e["ruby-merge"] = !1, e["ruby-position"] = !1, e["shape-image-threshold"] = !1, e["shape-outside"] = !1, e["shape-margin"] = !1, e.size = !1, e.speak = !1, e["speak-as"] = !1, e["speak-header"] = !1, e["speak-numeral"] = !1, e["speak-punctuation"] = !1, e["speech-rate"] = !1, e.stress = !1, e["string-set"] = !1, e["tab-size"] = !1, e["table-layout"] = !1, e["text-align"] = !0, e["text-align-last"] = !0, e["text-combine-upright"] = !0, e["text-decoration"] = !0, e["text-decoration-color"] = !0, e["text-decoration-line"] = !0, e["text-decoration-skip"] = !0, e["text-decoration-style"] = !0, e["text-emphasis"] = !0, e["text-emphasis-color"] = !0, e["text-emphasis-position"] = !0, e["text-emphasis-style"] = !0, e["text-height"] = !0, e["text-indent"] = !0, e["text-justify"] = !0, e["text-orientation"] = !0, e["text-overflow"] = !0, e["text-shadow"] = !0, e["text-space-collapse"] = !0, e["text-transform"] = !0, e["text-underline-position"] = !0, e["text-wrap"] = !0, e.top = !1, e.transform = !1, e["transform-origin"] = !1, e["transform-style"] = !1, e.transition = !1, e["transition-delay"] = !1, e["transition-duration"] = !1, e["transition-property"] = !1, e["transition-timing-function"] = !1, e["unicode-bidi"] = !1, e["vertical-align"] = !1, e.visibility = !1, e["voice-balance"] = !1, e["voice-duration"] = !1, e["voice-family"] = !1, e["voice-pitch"] = !1, e["voice-range"] = !1, e["voice-rate"] = !1, e["voice-stress"] = !1, e["voice-volume"] = !1, e.volume = !1, e["white-space"] = !1, e.widows = !1, e.width = !0, e["will-change"] = !1, e["word-break"] = !0, e["word-spacing"] = !0, e["word-wrap"] = !0, e["wrap-flow"] = !1, e["wrap-through"] = !1, e["writing-mode"] = !1, e["z-index"] = !1, e;
	}
	function n(e, t, n) {}
	function r(e, t, n) {}
	var i = /javascript\s*\:/gim;
	function a(e, t) {
		return i.test(t) ? "" : t;
	}
	e.whiteList = t(), e.getDefaultWhiteList = t, e.onAttr = n, e.onIgnoreAttr = r, e.safeAttrValue = a;
})), _ = /* @__PURE__ */ o(((e, t) => {
	t.exports = {
		indexOf: function(e, t) {
			var n, r;
			if (Array.prototype.indexOf) return e.indexOf(t);
			for (n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
			return -1;
		},
		forEach: function(e, t, n) {
			var r, i;
			if (Array.prototype.forEach) return e.forEach(t, n);
			for (r = 0, i = e.length; r < i; r++) t.call(n, e[r], r, e);
		},
		trim: function(e) {
			return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
		},
		trimRight: function(e) {
			return String.prototype.trimRight ? e.trimRight() : e.replace(/(\s*$)/g, "");
		}
	};
})), v = /* @__PURE__ */ o(((e, t) => {
	var n = _();
	function r(e, t) {
		e = n.trimRight(e), e[e.length - 1] !== ";" && (e += ";");
		var r = e.length, i = !1, a = 0, o = 0, s = "";
		function c() {
			if (!i) {
				var r = n.trim(e.slice(a, o)), c = r.indexOf(":");
				if (c !== -1) {
					var l = n.trim(r.slice(0, c)), u = n.trim(r.slice(c + 1));
					if (l) {
						var d = t(a, s.length, l, u, r);
						d && (s += d + "; ");
					}
				}
			}
			a = o + 1;
		}
		for (; o < r; o++) {
			var l = e[o];
			if (l === "/" && e[o + 1] === "*") {
				var u = e.indexOf("*/", o + 2);
				if (u === -1) break;
				o = u + 1, a = o + 1, i = !1;
			} else l === "(" ? i = !0 : l === ")" ? i = !1 : l === ";" ? i || c() : l === "\n" && c();
		}
		return n.trim(s);
	}
	t.exports = r;
})), y = /* @__PURE__ */ o(((e, t) => {
	var n = g(), r = v();
	_();
	function i(e) {
		return e == null;
	}
	function a(e) {
		var t = {};
		for (var n in e) t[n] = e[n];
		return t;
	}
	function o(e) {
		e = a(e || {}), e.whiteList = e.whiteList || n.whiteList, e.onAttr = e.onAttr || n.onAttr, e.onIgnoreAttr = e.onIgnoreAttr || n.onIgnoreAttr, e.safeAttrValue = e.safeAttrValue || n.safeAttrValue, this.options = e;
	}
	o.prototype.process = function(e) {
		if (e ||= "", e = e.toString(), !e) return "";
		var t = this.options, n = t.whiteList, a = t.onAttr, o = t.onIgnoreAttr, s = t.safeAttrValue;
		return r(e, function(e, t, r, c, l) {
			var u = n[r], d = !1;
			if (u === !0 ? d = u : typeof u == "function" ? d = u(c) : u instanceof RegExp && (d = u.test(c)), d !== !0 && (d = !1), c = s(r, c), c) {
				var f = {
					position: t,
					sourcePosition: e,
					source: l,
					isWhite: d
				};
				if (d) {
					var p = a(r, c, f);
					return i(p) ? r + ":" + c : p;
				} else {
					var p = o(r, c, f);
					if (!i(p)) return p;
				}
			}
		});
	}, t.exports = o;
})), b = /* @__PURE__ */ o(((e, t) => {
	var n = g(), r = y();
	function i(e, t) {
		return new r(t).process(e);
	}
	for (var a in e = t.exports = i, e.FilterCSS = r, n) e[a] = n[a];
	typeof window < "u" && (window.filterCSS = t.exports);
})), x = /* @__PURE__ */ o(((e, t) => {
	t.exports = {
		indexOf: function(e, t) {
			var n, r;
			if (Array.prototype.indexOf) return e.indexOf(t);
			for (n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
			return -1;
		},
		forEach: function(e, t, n) {
			var r, i;
			if (Array.prototype.forEach) return e.forEach(t, n);
			for (r = 0, i = e.length; r < i; r++) t.call(n, e[r], r, e);
		},
		trim: function(e) {
			return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
		},
		spaceIndex: function(e) {
			var t = /\s|\n|\t/.exec(e);
			return t ? t.index : -1;
		}
	};
})), S = /* @__PURE__ */ o(((e) => {
	var t = b().FilterCSS, n = b().getDefaultWhiteList, r = x();
	function i() {
		return {
			a: [
				"target",
				"href",
				"title"
			],
			abbr: ["title"],
			address: [],
			area: [
				"shape",
				"coords",
				"href",
				"alt"
			],
			article: [],
			aside: [],
			audio: [
				"autoplay",
				"controls",
				"crossorigin",
				"loop",
				"muted",
				"preload",
				"src"
			],
			b: [],
			bdi: ["dir"],
			bdo: ["dir"],
			big: [],
			blockquote: ["cite"],
			br: [],
			caption: [],
			center: [],
			cite: [],
			code: [],
			col: [
				"align",
				"valign",
				"span",
				"width"
			],
			colgroup: [
				"align",
				"valign",
				"span",
				"width"
			],
			dd: [],
			del: ["datetime"],
			details: ["open"],
			div: [],
			dl: [],
			dt: [],
			em: [],
			figcaption: [],
			figure: [],
			font: [
				"color",
				"size",
				"face"
			],
			footer: [],
			h1: [],
			h2: [],
			h3: [],
			h4: [],
			h5: [],
			h6: [],
			header: [],
			hr: [],
			i: [],
			img: [
				"src",
				"alt",
				"title",
				"width",
				"height",
				"loading"
			],
			ins: ["datetime"],
			kbd: [],
			li: [],
			mark: [],
			nav: [],
			ol: [],
			p: [],
			pre: [],
			s: [],
			section: [],
			small: [],
			span: [],
			sub: [],
			summary: [],
			sup: [],
			strong: [],
			strike: [],
			table: [
				"width",
				"border",
				"align",
				"valign"
			],
			tbody: ["align", "valign"],
			td: [
				"width",
				"rowspan",
				"colspan",
				"align",
				"valign"
			],
			tfoot: ["align", "valign"],
			th: [
				"width",
				"rowspan",
				"colspan",
				"align",
				"valign"
			],
			thead: ["align", "valign"],
			tr: [
				"rowspan",
				"align",
				"valign"
			],
			tt: [],
			u: [],
			ul: [],
			video: [
				"autoplay",
				"controls",
				"crossorigin",
				"loop",
				"muted",
				"playsinline",
				"poster",
				"preload",
				"src",
				"height",
				"width"
			]
		};
	}
	var a = new t();
	function o(e, t, n) {}
	function s(e, t, n) {}
	function c(e, t, n) {}
	function l(e, t, n) {}
	function u(e) {
		return e.replace(f, "&lt;").replace(p, "&gt;");
	}
	function d(e, t, n, i) {
		if (n = k(n), t === "href" || t === "src") {
			if (n = r.trim(n), n === "#") return "#";
			if (!(n.substr(0, 7) === "http://" || n.substr(0, 8) === "https://" || n.substr(0, 7) === "mailto:" || n.substr(0, 4) === "tel:" || n.substr(0, 11) === "data:image/" || n.substr(0, 6) === "ftp://" || n.substr(0, 2) === "./" || n.substr(0, 3) === "../" || n[0] === "#" || n[0] === "/")) return "";
		} else if (t === "background") {
			if (y.lastIndex = 0, y.test(n)) return "";
		} else if (t === "style") {
			if (S.lastIndex = 0, S.test(n) || (C.lastIndex = 0, C.test(n) && (y.lastIndex = 0, y.test(n)))) return "";
			i !== !1 && (i ||= a, n = i.process(n));
		}
		return n = A(n), n;
	}
	var f = /</g, p = />/g, m = /"/g, h = /&quot;/g, g = /&#([a-zA-Z0-9]*);?/gim, _ = /&colon;?/gim, v = /&newline;?/gim, y = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi, S = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi, C = /u\s*r\s*l\s*\(.*/gi;
	function w(e) {
		return e.replace(m, "&quot;");
	}
	function T(e) {
		return e.replace(h, "\"");
	}
	function E(e) {
		return e.replace(g, function(e, t) {
			return t[0] === "x" || t[0] === "X" ? String.fromCharCode(parseInt(t.substr(1), 16)) : String.fromCharCode(parseInt(t, 10));
		});
	}
	function D(e) {
		return e.replace(_, ":").replace(v, " ");
	}
	function O(e) {
		for (var t = "", n = 0, i = e.length; n < i; n++) t += e.charCodeAt(n) < 32 ? " " : e.charAt(n);
		return r.trim(t);
	}
	function k(e) {
		return e = T(e), e = E(e), e = D(e), e = O(e), e;
	}
	function A(e) {
		return e = w(e), e = u(e), e;
	}
	function j() {
		return "";
	}
	function M(e, t) {
		typeof t != "function" && (t = function() {});
		var n = !Array.isArray(e);
		function i(t) {
			return n ? !0 : r.indexOf(e, t) !== -1;
		}
		var a = [], o = !1;
		return {
			onIgnoreTag: function(e, n, r) {
				if (i(e)) if (r.isClosing) {
					var s = "[/removed]", c = r.position + s.length;
					return a.push([o === !1 ? r.position : o, c]), o = !1, s;
				} else return o ||= r.position, "[removed]";
				else return t(e, n, r);
			},
			remove: function(e) {
				var t = "", n = 0;
				return r.forEach(a, function(r) {
					t += e.slice(n, r[0]), n = r[1];
				}), t += e.slice(n), t;
			}
		};
	}
	function N(e) {
		for (var t = "", n = 0; n < e.length;) {
			var r = e.indexOf("<!--", n);
			if (r === -1) {
				t += e.slice(n);
				break;
			}
			t += e.slice(n, r);
			var i = e.indexOf("-->", r);
			if (i === -1) break;
			n = i + 3;
		}
		return t;
	}
	function P(e) {
		var t = e.split("");
		return t = t.filter(function(e) {
			var t = e.charCodeAt(0);
			return t === 127 ? !1 : t <= 31 ? t === 10 || t === 13 : !0;
		}), t.join("");
	}
	e.whiteList = i(), e.getDefaultWhiteList = i, e.onTag = o, e.onIgnoreTag = s, e.onTagAttr = c, e.onIgnoreTagAttr = l, e.safeAttrValue = d, e.escapeHtml = u, e.escapeQuote = w, e.unescapeQuote = T, e.escapeHtmlEntities = E, e.escapeDangerHtml5Entities = D, e.clearNonPrintableCharacter = O, e.friendlyAttrValue = k, e.escapeAttrValue = A, e.onIgnoreTagStripAll = j, e.StripTagBody = M, e.stripCommentTag = N, e.stripBlankChar = P, e.attributeWrapSign = "\"", e.cssFilter = a, e.getDefaultCSSWhiteList = n;
})), C = /* @__PURE__ */ o(((e) => {
	var t = x();
	function n(e) {
		var n = t.spaceIndex(e), r = n === -1 ? e.slice(1, -1) : e.slice(1, n + 1);
		return r = t.trim(r).toLowerCase(), r.slice(0, 1) === "/" && (r = r.slice(1)), r.slice(-1) === "/" && (r = r.slice(0, -1)), r;
	}
	function r(e) {
		return e.slice(0, 2) === "</";
	}
	function i(e, t, i) {
		var a = "", o = 0, s = !1, c = !1, l = 0, u = e.length, d = "", f = "";
		chariterator: for (l = 0; l < u; l++) {
			var p = e.charAt(l);
			if (s === !1) {
				if (p === "<") {
					s = l;
					continue;
				}
			} else if (c === !1) {
				if (p === "<") {
					a += i(e.slice(o, l)), s = l, o = l;
					continue;
				}
				if (p === ">" || l === u - 1) {
					a += i(e.slice(o, s)), f = e.slice(s, l + 1), d = n(f), a += t(s, a.length, d, f, r(f)), o = l + 1, s = !1;
					continue;
				}
				if (p === "\"" || p === "'") for (var m = 1, h = e.charAt(l - m); h.trim() === "" || h === "=";) {
					if (h === "=") {
						c = p;
						continue chariterator;
					}
					h = e.charAt(l - ++m);
				}
			} else if (p === c) {
				c = !1;
				continue;
			}
		}
		return o < u && (a += i(e.substr(o))), a;
	}
	var a = /[^a-zA-Z0-9\\_:.-]/gim;
	function o(e, n) {
		var r = 0, i = 0, o = [], u = !1, f = e.length;
		function p(e, r) {
			if (e = t.trim(e), e = e.replace(a, "").toLowerCase(), !(e.length < 1)) {
				var i = n(e, r || "");
				i && o.push(i);
			}
		}
		for (var m = 0; m < f; m++) {
			var h = e.charAt(m), g, _;
			if (u === !1 && h === "=") {
				u = e.slice(r, m), r = m + 1, i = e.charAt(r) === "\"" || e.charAt(r) === "'" ? r : c(e, m + 1);
				continue;
			}
			if (u !== !1 && m === i) {
				if (_ = e.indexOf(h, m + 1), _ === -1) break;
				g = t.trim(e.slice(i + 1, _)), p(u, g), u = !1, m = _, r = m + 1;
				continue;
			}
			if (/\s|\n|\t/.test(h)) if (e = e.replace(/\s|\n|\t/g, " "), u === !1) if (_ = s(e, m), _ === -1) {
				g = t.trim(e.slice(r, m)), p(g), u = !1, r = m + 1;
				continue;
			} else {
				m = _ - 1;
				continue;
			}
			else if (_ = l(e, m - 1), _ === -1) {
				g = t.trim(e.slice(r, m)), g = d(g), p(u, g), u = !1, r = m + 1;
				continue;
			} else continue;
		}
		return r < e.length && (u === !1 ? p(e.slice(r)) : p(u, d(t.trim(e.slice(r))))), t.trim(o.join(" "));
	}
	function s(e, t) {
		for (; t < e.length; t++) {
			var n = e[t];
			if (n !== " ") return n === "=" ? t : -1;
		}
	}
	function c(e, t) {
		for (; t < e.length; t++) {
			var n = e[t];
			if (n !== " ") return n === "'" || n === "\"" ? t : -1;
		}
	}
	function l(e, t) {
		for (; t > 0; t--) {
			var n = e[t];
			if (n !== " ") return n === "=" ? t : -1;
		}
	}
	function u(e) {
		return e[0] === "\"" && e[e.length - 1] === "\"" || e[0] === "'" && e[e.length - 1] === "'";
	}
	function d(e) {
		return u(e) ? e.substr(1, e.length - 2) : e;
	}
	e.parseTag = i, e.parseAttr = o;
})), w = /* @__PURE__ */ o(((e, t) => {
	var n = b().FilterCSS, r = S(), i = C(), a = i.parseTag, o = i.parseAttr, s = x();
	function c(e) {
		return e == null;
	}
	function l(e) {
		var t = s.spaceIndex(e);
		if (t === -1) return {
			html: "",
			closing: e[e.length - 2] === "/"
		};
		e = s.trim(e.slice(t + 1, -1));
		var n = e[e.length - 1] === "/";
		return n && (e = s.trim(e.slice(0, -1))), {
			html: e,
			closing: n
		};
	}
	function u(e) {
		var t = {};
		for (var n in e) t[n] = e[n];
		return t;
	}
	function d(e) {
		var t = {};
		for (var n in e) Array.isArray(e[n]) ? t[n.toLowerCase()] = e[n].map(function(e) {
			return e.toLowerCase();
		}) : t[n.toLowerCase()] = e[n];
		return t;
	}
	function f(e) {
		e = u(e || {}), e.stripIgnoreTag && (e.onIgnoreTag && console.error("Notes: cannot use these two options \"stripIgnoreTag\" and \"onIgnoreTag\" at the same time"), e.onIgnoreTag = r.onIgnoreTagStripAll), e.whiteList || e.allowList ? e.whiteList = d(e.whiteList || e.allowList) : e.whiteList = r.whiteList, this.attributeWrapSign = e.singleQuotedAttributeValue === !0 ? "'" : r.attributeWrapSign, e.onTag = e.onTag || r.onTag, e.onTagAttr = e.onTagAttr || r.onTagAttr, e.onIgnoreTag = e.onIgnoreTag || r.onIgnoreTag, e.onIgnoreTagAttr = e.onIgnoreTagAttr || r.onIgnoreTagAttr, e.safeAttrValue = e.safeAttrValue || r.safeAttrValue, e.escapeHtml = e.escapeHtml || r.escapeHtml, this.options = e, e.css === !1 ? this.cssFilter = !1 : (e.css = e.css || {}, this.cssFilter = new n(e.css));
	}
	f.prototype.process = function(e) {
		if (e ||= "", e = e.toString(), !e) return "";
		var t = this, n = t.options, i = n.whiteList, u = n.onTag, d = n.onIgnoreTag, f = n.onTagAttr, p = n.onIgnoreTagAttr, m = n.safeAttrValue, h = n.escapeHtml, g = t.attributeWrapSign, _ = t.cssFilter;
		n.stripBlankChar && (e = r.stripBlankChar(e)), n.allowCommentTag || (e = r.stripCommentTag(e));
		var v = !1;
		n.stripIgnoreTagBody && (v = r.StripTagBody(n.stripIgnoreTagBody, d), d = v.onIgnoreTag);
		var y = a(e, function(e, t, n, r, a) {
			var v = {
				sourcePosition: e,
				position: t,
				isClosing: a,
				isWhite: Object.prototype.hasOwnProperty.call(i, n)
			}, y = u(n, r, v);
			if (!c(y)) return y;
			if (v.isWhite) {
				if (v.isClosing) return "</" + n + ">";
				var b = l(r), x = i[n], S = o(b.html, function(e, t) {
					var r = s.indexOf(x, e) !== -1, i = f(n, e, t, r);
					return c(i) ? r ? (t = m(n, e, t, _), t ? e + "=" + g + t + g : e) : (i = p(n, e, t, r), c(i) ? void 0 : i) : i;
				});
				return r = "<" + n, S && (r += " " + S), b.closing && (r += " /"), r += ">", r;
			} else return y = d(n, r, v), c(y) ? h(r) : y;
		}, h);
		return v && (y = v.remove(y)), y;
	}, t.exports = f;
})), T = /* @__PURE__ */ c((/* @__PURE__ */ o(((e, t) => {
	var n = S(), r = C(), i = w();
	function a(e, t) {
		return new i(t).process(e);
	}
	e = t.exports = a, e.filterXSS = a, e.FilterXSS = i, (function() {
		for (var t in n) e[t] = n[t];
		for (var i in r) e[i] = r[i];
	})(), typeof window < "u" && (window.filterXSS = t.exports);
	function o() {
		return typeof self < "u" && typeof DedicatedWorkerGlobalScope < "u" && self instanceof DedicatedWorkerGlobalScope;
	}
	o() && (self.filterXSS = t.exports);
})))(), 1), E = {
	allowList: {
		a: [
			"style",
			"class",
			"href",
			"title",
			"target",
			"rel"
		],
		abbr: [
			"style",
			"class",
			"title"
		],
		time: [
			"style",
			"class",
			"datetime"
		],
		span: ["style", "class"],
		b: ["style", "class"],
		i: ["style", "class"],
		em: ["style", "class"],
		strong: ["style", "class"],
		u: ["style", "class"],
		s: ["style", "class"],
		sub: ["style", "class"],
		sup: ["style", "class"],
		br: ["style", "class"],
		small: ["style", "class"],
		code: ["style", "class"],
		kbd: ["style", "class"],
		mark: ["style", "class"]
	},
	stripIgnoreTag: !0
};
function D(e) {
	return (0, T.default)(e, E).trim();
}
//#endregion
//#region src/timings.ts
function O(e, t) {
	let n = t - e;
	return n < 1e3 ? `${Math.round(n)}ms` : `${(n / 1e3).toFixed(2)}s`;
}
var k = class e {
	headers;
	constructor(e) {
		this.headers = e;
	}
	get timings() {
		let e = this.headers.get("Server-Timing")?.split(",").map((e) => e.trim()) || [], t = /* @__PURE__ */ new Map();
		return e.forEach((e) => {
			let n = e.split(";").map((e) => e.trim()), r = n[0], i = n.find((e) => e.startsWith("desc=")), a = n.find((e) => e.startsWith("dur=")), o = i ? i.split("=")[1]?.replace(/"/g, "") : "", s = a ? a.split("=")[1] : "";
			if (r && s !== void 0) {
				let e = parseFloat(s);
				t.set(r, {
					description: o,
					duration: e
				});
			}
		}), t;
	}
	set timings(t) {
		let n = Array.from(t.entries()).map(([t, { description: n, duration: r }]) => e.asTimingString(t, r, n));
		this.headers.set("Server-Timing", n.join(", "));
	}
	setTiming(e, t, n) {
		let r = this.timings;
		r.set(e, {
			description: n,
			duration: t
		}), this.timings = r;
	}
	static setTiming(t, n, r, i) {
		let a = new e(t);
		return a.setTiming(n, r, i), a.toString();
	}
	static asTimingString(e, t, n) {
		let r = e;
		return n && (r += `;desc="${n}"`), r += `;dur=${t}`, r;
	}
	toString() {
		return this.headers.get("Server-Timing") || "";
	}
	toJSON() {
		return this.toString();
	}
	static merge(...t) {
		let n = /* @__PURE__ */ new Map();
		t.forEach((t) => {
			(t instanceof e ? t : new e(t)).timings.forEach((e, t) => {
				n.set(t, e);
			});
		});
		let r = new e(new Headers());
		return r.timings = n, r;
	}
};
//#endregion
export { k as ServerTimingHelper, O as formatDuration, u as hash, f as hashSync, p as isJSON, m as kebabCaseToPascalCase, h as pascalCaseToKebabCase, D as sanitizeInlineHtml, d as uint8ToHex };
